import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class CustomBuilderService {
  constructor(private http: HttpClient) {}

  public getAllBuilders() {
    return this.http
      .get(environment.apiUrl + 'api/ext-builder')
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Get all Builders by Store Id
  public getAllBuildersByStore(id) {
    return this.http
      .get(environment.apiUrl + 'api/ext-builder/by-store/' + id + '?size=9999')
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Get individual builder
  public getBuilderById(id) {
    return this.http
      .get(environment.apiUrl + 'api/ext-builder/' + id)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Create New Builder
  public createBuilder(storeid, obj) {
    const body = {
      basePrice: obj.basePrice,
      description: obj.description,
      itemCategoryId: obj.itemCategoryId,
      itemCategoryKioskId: obj.itemCategoryKioskId,
      name: obj.name,
      storeId: storeid,
    };
    return this.http
      .post(environment.apiUrl + 'api/ext-builder', body)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Edit Existing Builder
  public editBuilder(builderid, obj) {
    const body = {
      basePrice: obj.basePrice,
      description: obj.description,
      itemCategoryId: obj.itemCategoryId,
      itemCategoryKioskId: obj.itemCategoryKioskId,
      foodToGoItemCategoryId: obj.foodToGoCategoryId,
      name: obj.name,
      id: builderid,
    };
    return this.http
      .put(environment.apiUrl + 'api/ext-builder', body)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Delete Builder
  public deleteBuilder(id) {
    return this.http
      .delete(environment.apiUrl + 'api/ext-builder/' + id)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // ############# //
  // BUILDER STEPS //
  // ############# //

  // Get all steps for a builder
  public getAllBuilderSteps(id) {
    return this.http
      .get(environment.apiUrl + 'api/ext-builder-step/by-builder/' + id + '?size=9999')
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Create new builder step
  public createBuilderStep(builderid, obj) {
    const body = {
      amountFree: obj.amountFree,
      builderId: builderid,
      description: obj.description,
      maximum: obj.maximum,
      minimum: obj.minimum,
      multiple: obj.multiple,
      name: obj.name,
      order: obj.order,
    };
    return this.http
      .post(environment.apiUrl + 'api/ext-builder-step', body)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public editBuilderStep(obj) {
    return this.http
      .put(environment.apiUrl + 'api/ext-builder-step', obj)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public deleteBuilderStep(id) {
    return this.http
      .delete(environment.apiUrl + 'api/ext-builder-step/' + id)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // ############# //
  // BUILDER STEPS //
  // ############# //

  public getAllBuilderStepItemsByBuilderStep(id) {
    return this.http
      .get(environment.apiUrl + 'api/ext-builder-step-item/by-builder-step/' + id + '?size=9999')
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public createBuilderStepItem(builderstepid, obj) {
    const body = {
      name: obj.name,
      description: obj.description,
      price: obj.price,
      extraPrice: obj.extraPrice,
      builderStepId: builderstepid,
    };
    return this.http
      .post(environment.apiUrl + 'api/ext-builder-step-item', body)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public editBuilderStepItem(obj) {
    return this.http
      .put(environment.apiUrl + 'api/ext-builder-step-item', obj)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public deleteBuilderStepItem(id) {
    return this.http
      .delete(environment.apiUrl + 'api/ext-builder-step-item/' + id)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // HANDLE DATA
  private handleData(res: HttpResponse<any>) {
    const body = res;
    return body;
  }

  public handleDataWithHeaders(res: HttpResponse<any>) {
    const headers = res.headers;
    const body = res.body;
    const data = {
      headers: headers,
      body: body,
    };
    return data;
  }

  private handleError(error: any) {
    return Observable.throw(new HttpErrorResponse(error));
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/custom-bulider.service.ts